import { PlayerState, LobbyPlayer } from './player';
import { MatchState, MatchResult } from './match';
import { CardDef, CardTier } from './card';

// ゲームフェイズ
export type GamePhase =
  | 'lobby'         // ロビー待機
  | 'starterSelect' // スターターデッキ選択
  | 'deckPhase'     // デッキフェイズ
  | 'matchPhase'    // マッチフェイズ
  | 'roundEnd'      // ラウンド終了
  | 'finals'        // 決勝
  | 'gameEnd';      // ゲーム終了

// ゲーム設定
export interface GameConfig {
  maxPlayers: number;           // 最大プレイヤー数 (2-8)
  qualifyingRounds: number;     // 予選ラウンド数 (デフォルト7)
  finalistsCount: number;       // 決勝進出者数 (デフォルト2)
  deckPhaseTimeLimit: number;   // デッキフェイズ制限時間 (秒)
  fillWithBots: boolean;        // 足りない場合Botで補充
  tierDraws?: Record<CardTier, number>[];  // ラウンドごとのティア取得枚数
}

// デフォルト設定
export const DEFAULT_GAME_CONFIG: GameConfig = {
  maxPlayers: 8,
  qualifyingRounds: 7,
  finalistsCount: 2,
  deckPhaseTimeLimit: 60,
  fillWithBots: true,
};

// 会場 (プレイマット) 定義
export interface Venue {
  id: string;
  name: string;
  description: string;
  availableCards: string[];  // 入手可能カードID
  specialEffect?: VenueEffect;
}

// 会場特殊効果
export interface VenueEffect {
  type: 'discount' | 'bonus' | 'exclusive';
  value?: number;
  description: string;
}

// ラウンド状態
export interface RoundState {
  roundNumber: number;
  phase: 'deck' | 'match';
  matches: MatchState[];
  matchResults: MatchResult[];
}

// ゲーム全体の状態
export interface GameState {
  gameId: string;
  config: GameConfig;
  phase: GamePhase;
  players: PlayerState[];
  currentRound: RoundState | null;
  roundHistory: RoundState[];
  cardPool: CardDef[];
  unlockedCardIds: string[];  // 現ラウンドまでに解禁されたカード
  finalists: string[];        // 決勝進出者ID
  champion?: string;          // 優勝者ID
  createdAt: number;
  updatedAt: number;
}

// ロビー状態
export interface LobbyState {
  lobbyId: string;
  hostId: string;
  players: LobbyPlayer[];
  config: GameConfig;
  status: 'waiting' | 'starting' | 'inGame';
}

// イベント種別 (状態更新通知用)
export type GameEventType =
  | 'playerJoined'
  | 'playerLeft'
  | 'gameStarted'
  | 'phaseChanged'
  | 'roundStarted'
  | 'roundEnded'
  | 'matchStarted'
  | 'matchUpdated'
  | 'matchEnded'
  | 'finalsStarted'
  | 'gameEnded';

// ゲームイベント
export interface GameEvent {
  type: GameEventType;
  timestamp: number;
  data: unknown;
}
